export enum MultiTabsActionType {
    ADD_TAB = 'ADD_TAB',
    REMOVE_TAB = 'REMOVE_TAB',
    DISMISS_TOUR = 'DISMISS_TOUR'
}
